/** How busy the road is. Multiplies the spawn rate (the daily theme still adds its own on top). */
export type TrafficLevel = 'light' | 'normal' | 'busy';

export const TRAFFIC_LEVELS: readonly { id: TrafficLevel; label: string; density: number }[] = [
  { id: 'light', label: 'Light', density: 0.6 },
  { id: 'normal', label: 'Normal', density: 1 },
  { id: 'busy', label: 'Busy', density: 1.5 },
];

export function trafficDensity(level: TrafficLevel): number {
  return TRAFFIC_LEVELS.find((l) => l.id === level)?.density ?? 1;
}
